var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-slider',_vm._b({model:{value:(_setup.iValue),callback:function ($$v) {_setup.iValue=$$v},expression:"iValue"}},'v-slider',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }